import React from "react";
import { ManageCustodianContainer } from "../../../containers";

const ManageCustodian = (props) => {
  return <ManageCustodianContainer {...props} />;
};

export default ManageCustodian;
